module.exports = __webpack_public_path__ + "0352f42fcc5aac7257d641348920a434.pdf";